import { render, staticRenderFns } from "./ContractsAgent.vue?vue&type=template&id=0d98cc02&scoped=true&"
import script from "./ContractsAgent.vue?vue&type=script&lang=js&"
export * from "./ContractsAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98cc02",
  null
  
)

export default component.exports